import { ISelectionVariantType } from 'redux-store/api/selection-variant';
import { ICommonSelectValues } from 'utils/types';
import { TOptionVariant } from 'widgets/selections/utils/types';

export const getExistingVariantNames = (variants: TOptionVariant[]): string[] =>
  variants?.map((variant) => variant.name);

export const getSelectableVariants = (
  currentVariantName: string,
  currentVariants: TOptionVariant[],
  variantTypes: ISelectionVariantType[]
): ICommonSelectValues[] => {
  const existingNames = getExistingVariantNames(currentVariants);
  if (!variantTypes) return [];

  return variantTypes
    .filter(({ name }) => {
      if (currentVariantName && name === currentVariantName) return true;
      return !existingNames?.includes(name);
    })
    .map(({ id, name }) => ({ label: name, value: id }));
};

export const adaptVariantToLibraryForm = (
  variantToEdit: TOptionVariant,
  variants: ISelectionVariantType[]
): TOptionVariant => {
  const { name, options } = variantToEdit;

  const id = variants?.find((item) => item.name === name)?.id;

  return {
    name,
    id,
    options: options.map((option) => ({ name: option.name, orderNo: option.orderNo })),
  };
};
